import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import PublicRoute from './PublicRoute';
import SignInPage from 'SiginIn';
import ContractPage from 'pages/contract/ContractPage';
import ManageStorePage from 'pages/manage-store/ManageStorePage';
import ProfilePage from 'pages/profile/ProfilePage';
import AppLayout from 'layout/AppLayout';
import ContractDetailPage from 'pages/contract/ContractDetailPage';
import ManageStoreDetailPage from 'pages/manage-store/ManageStoreDetailPage';
import EditProfilePage from 'pages/profile/EditProfilePage';
import FAQPage from 'pages/faq/FAQPage';
import PrivateRoute from 'PrivateRoute';
import Gate from 'Gate';

const App: React.FC = () => {
  return (
    <div style={{ height: "100%", minHeight: "100vh" }}>
      <Routes>
        <Route path="/" element={
          <Gate />
        } />
        <Route
          path="/sign-in"
          element={
            <PublicRoute>
              <SignInPage />
            </PublicRoute>
          }
        />
        <Route path="/" element={<AppLayout />}>
          <Route path="contracts" element={<PrivateRoute><ContractPage /></PrivateRoute>} />
          <Route path="contracts/:id" element={<PrivateRoute><ContractDetailPage /></PrivateRoute>} />
          <Route path="manage-store" element={<PrivateRoute><ManageStorePage /></PrivateRoute>} />
          <Route path="manage-store/:id" element={<PrivateRoute><ManageStoreDetailPage /></PrivateRoute>} />
          <Route path="profile" element={<PrivateRoute><ProfilePage /></PrivateRoute>} />
          <Route path="profile/edit" element={<PrivateRoute><EditProfilePage /></PrivateRoute>} />
          <Route path="profile/faq" element={<PrivateRoute><FAQPage /></PrivateRoute>} />
        </Route>
      </Routes>
    </div>
  );
};

export default App;
